(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["penrith-about-the-founder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-penrith-practitioner-section]');

    sections.forEach((section) => {
      if (section.dataset.clinicalCasesReady === 'true') return;
      section.dataset.clinicalCasesReady = 'true';

      const cases = section.querySelector('[data-penrith-clinical-cases]');
      const toggle = cases?.querySelector('[data-penrith-cases-toggle]');
      const toggleLabel = cases?.querySelector('[data-penrith-cases-toggle-label]');
      const disclosure = cases?.querySelector('[data-penrith-cases-disclosure]');
      const dialog = cases?.querySelector('[data-penrith-lightbox]');
      const dialogImage = dialog?.querySelector('[data-penrith-lightbox-image]');
      const dialogCaption = dialog?.querySelector('[data-penrith-lightbox-caption]');
      const dialogClose = dialog?.querySelector('[data-penrith-lightbox-close]');
      let disclosureTimer;
      let lastLightboxTrigger;

      if (!toggle || !toggleLabel || !disclosure) return;

      const setDisclosure = (open) => {
        window.clearTimeout(disclosureTimer);
        toggle.setAttribute('aria-expanded', String(open));
        toggleLabel.textContent = open ? 'Hide the case studies ↑' : 'Read the case studies ↓';

        if (open) {
          disclosure.hidden = false;
          window.requestAnimationFrame(() => disclosure.classList.add('is-open'));
          return;
        }

        disclosure.classList.remove('is-open');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reducedMotion) {
          disclosure.hidden = true;
          toggle.focus({ preventScroll: true });
          return;
        }

        disclosureTimer = window.setTimeout(() => {
          if (toggle.getAttribute('aria-expanded') === 'false') {
            disclosure.hidden = true;
            toggle.focus({ preventScroll: true });
          }
        }, 340);
      };

      toggle.addEventListener('click', () => {
        setDisclosure(toggle.getAttribute('aria-expanded') !== 'true');
      });

      toggle.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setDisclosure(toggle.getAttribute('aria-expanded') !== 'true');
        }
      });

      cases.querySelectorAll('[data-penrith-lightbox-trigger]').forEach((trigger) => {
        const openLightbox = () => {
          if (!dialog || !dialogImage || !dialogCaption || typeof dialog.showModal !== 'function') return;
          lastLightboxTrigger = trigger;
          dialogImage.src = trigger.dataset.lightboxSrc || '';
          dialogImage.alt = trigger.dataset.lightboxAlt || '';
          dialogCaption.textContent = trigger.dataset.lightboxCaption || '';
          dialog.showModal();
          dialogClose?.focus();
        };

        trigger.addEventListener('click', openLightbox);

        trigger.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openLightbox();
          }
        });
      });

      dialogClose?.addEventListener('click', () => dialog.close());

      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      dialog?.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && dialog.open) {
          event.preventDefault();
          dialog.close();
        }
      });

      dialog?.addEventListener('close', () => {
        dialogImage?.removeAttribute('src');
        lastLightboxTrigger?.focus();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
